import styled from 'styled-components'

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Ubuntu;
  padding-bottom: 40px;
`
export const ButtonNextContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: end;

  .button-action {
    margin-left: auto;
    margin-top: 20px;
    button {
      margin: 0;
    }
  }
`

export const Title = styled.h1`
  margin-bottom: 20px;
  font-family: Ubuntu, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 2px;
  text-align: left;
`
export const Cell = styled.td`
  padding: 8px;
  font-family: Ubuntu, sans-serif;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  letter-spacing: 0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
`

export const CellNoPadding = styled(Cell)`
  padding: 10px 0;
`

export const AnimalInsuranceListContainer = styled.div`
  width: 100%;
  align-items: center;
`

export const TableContainer = styled.div`
  overflow-x: auto;
  box-shadow: 0px 40px 40px 0px #0000001a;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`

export const Header = styled.th`
  padding: 8px 8px 8px 20px;
  background-color: #0093b2;
  font-family: Ubuntu, sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: #ffffff;
  line-height: 18px;
  letter-spacing: 0.05em;
  text-align: left;
`

export const ActionHeader = styled(Header)`
  width: 90px;
`

export const Row = styled.tr`
  border-style: solid;
  border-width: 0 0 1px 0;
  border-color: #f6f6f6;
`

export const RowNoPadding = styled(Row)`
  padding: 10px 0;
`

export const RowWithourBorder = styled.tr`
  border-style: solid;
  border-width: 0 0 0 0;
`
